import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import '../../Styles/Common/Banniere.scss';
import { useNavigate } from 'react-router';

const Banner: React.FC = () => {
    const [showBanner, setShowBanner] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        const checkCookiesAccepted = () => {
            if (window.getCkyConsent) {
                const consent = window.getCkyConsent();
                return consent.categories.functional;
            }
            return false;
        };

        const cookiesAccepted = checkCookiesAccepted();
        const premiereVisite = localStorage.getItem('premiereVisite') === 'true';
        if (cookiesAccepted) {
            if (premiereVisite) {
                setShowBanner(false);
            } else {
                setShowBanner(true);
            }
        } else {
            setShowBanner(true);
        }
    }, []);

    const handleBannerAction = () => {
        setShowBanner(false);
        localStorage.setItem('premiereVisite', 'true');
    };

    const scrollToSection = (id: string, offset: number) => {
        const section = document.getElementById(id);
        if (section) {
            const yOffset = -offset;
            const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const handleScrollOrNavigate = (sectionId: string) => {
        if (location.pathname === '/') {
            scrollToSection(sectionId, 200);
            const videoElement = document.querySelector(`#${sectionId} video`) as HTMLVideoElement;
            if (videoElement) {
                setTimeout(() => {
                    videoElement.play();
                }, 1000); // Attendez 1 seconde avant de jouer la vidéo
            }
        } else {
            navigate(`/?id=${sectionId}`);
            setTimeout(() => {
                scrollToSection(sectionId, 200);
                const videoElement = document.querySelector(`#${sectionId} video`) as HTMLVideoElement;
                if (videoElement) {
                    videoElement.play();
                }
            }, 1000); // Attendez 1 seconde avant de défiler et de jouer la vidéo
        }
    };

    const goToVideoTuto = () => {
        handleScrollOrNavigate('VideoTuto');
        handleBannerAction();
    };

    if (!showBanner) return null;

    return (
        <div className="banner-container d-flex align-items-center">
            <div className="banner-logo-container">
                <img
                    src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/logo192.png"
                    alt="Logo"
                    className="banner-logo"
                />
            </div>
            <div className="banner-text">
                Première fois sur notre site ? Ne manquez pas notre vidéo d'accueil ! Cliquez sur une activité pour plus
                de détails.
            </div>

            <div className="banner-arrow-container d-flex ">
                <img
                    src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/arrow-post-tips.png"
                    alt="Arrow"
                    className="banner-arrow"
                />
                <Button
                    bsPrefix="banner-button"
                    onClick={() => {
                        goToVideoTuto();
                    }}
                >
                    <span className="banner-button-text">COMMENCER</span>
                </Button>
            </div>
            <button className="banner-close" onClick={() => handleBannerAction()}>
                ×
            </button>
        </div>
    );
};

export default Banner;
